export const FIELD_RULES = {
  isHidden: 'isHidden',
  isMandatory: 'isMandatory',
  isOptional: 'isOptional',
  isReadOnly: 'isReadOnly',
}

export type FieldRule = ValueOf<typeof FIELD_RULES>

export const FIELD_STATUSES = {
  isHidden: 'isHidden',
  isMandatory: 'isMandatory',
  isOptional: 'isOptional',
  isReadOnly: 'isReadOnly',
  isNotInSchema: false,
}

export type FieldStatus = ValueOf<typeof FIELD_STATUSES>

export type FieldStatusesByOriginKey = Record<string, FieldStatus | undefined>

export const NO_BANK_NAME_CATEGORIES = {
  biens_d_usage: true,
  immobilier_de_rapport: true,
  biens_professionnels: true,
}

export const MAX_NATIONALITIES_PER_PERSON = 4
